import React, { Component } from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
// import BootstrapSelect from 'react-bootstrap-select-dropdown';
import PubSub from 'pubsub-js';
import ScreenerSelect from './ScreenerSelect';

const priceOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'priceLowerThan', value: '1' }, "value": "Under $1" },
    { "labelKey": { criteria: 'priceLowerThan', value: '2' }, "value": "Under $2" },
    { "labelKey": { criteria: 'priceLowerThan', value: '4' }, "value": "Under $4" },
    { "labelKey": { criteria: 'priceLowerThan', value: '6' }, "value": "Under $6" },
    { "labelKey": { criteria: 'priceLowerThan', value: '8' }, "value": "Under $8" },
    { "labelKey": { criteria: 'priceLowerThan', value: '10' }, "value": "Under $10" },
    { "labelKey": { criteria: 'priceLowerThan', value: '20' }, "value": "Under $20" },
    { "labelKey": { criteria: 'priceLowerThan', value: '30' }, "value": "Under $30" },
    { "labelKey": { criteria: 'priceLowerThan', value: '40' }, "value": "Under $40" },
    { "labelKey": { criteria: 'priceLowerThan', value: '50' }, "value": "Under $50" },
    { "labelKey": { criteria: 'priceMoreThan', value: '1' }, "value": "Over $1" },
    { "labelKey": { criteria: 'priceMoreThan', value: '2' }, "value": "Over $2" },
    { "labelKey": { criteria: 'priceMoreThan', value: '4' }, "value": "Over $4" },
    { "labelKey": { criteria: 'priceMoreThan', value: '6' }, "value": "Over $6" },
    { "labelKey": { criteria: 'priceMoreThan', value: '8' }, "value": "Over $8" },
    { "labelKey": { criteria: 'priceMoreThan', value: '10' }, "value": "Over $10" },
    { "labelKey": { criteria: 'priceMoreThan', value: '20' }, "value": "Over $20" },
    { "labelKey": { criteria: 'priceMoreThan', value: '30' }, "value": "Over $30" },
    { "labelKey": { criteria: 'priceMoreThan', value: '40' }, "value": "Over $40" },
    { "labelKey": { criteria: 'priceMoreThan', value: '50' }, "value": "Over $50" },
    { "labelKey": { criteria: 'between', value: '0', from: 1, to: 5 }, "value": "$1 to $5" },
    { "labelKey": { criteria: 'between', value: '0', from: 1, to: 10 }, "value": "$1 to $10" },
    { "labelKey": { criteria: 'between', value: '0', from: 1, to: 20 }, "value": "$1 to $20" },
    { "labelKey": { criteria: 'between', value: '0', from: 5, to: 10 }, "value": "$5 to $10" },
    { "labelKey": { criteria: 'between', value: '0', from: 5, to: 50 }, "value": "$5 to $50" },
    { "labelKey": { criteria: 'between', value: '0', from: 5, to: 100 }, "value": "$5 to $100" },
    { "labelKey": { criteria: 'between', value: '0', from: 10, to: 20 }, "value": "$10 to $20" },
    { "labelKey": { criteria: 'between', value: '0', from: 10, to: 50 }, "value": "$10 to $50" },
    { "labelKey": { criteria: 'between', value: '0', from: 20, to: 50 }, "value": "$20 to $50" },
    { "labelKey": { criteria: 'between', value: '0', from: 50, to: 100 }, "value": "$50 to $100" },
    { "labelKey": { criteria: 'between', value: '0', from: 100, to: 200 }, "value": "$100 to $200" },
];

//Country : US - UK - MX - BR - RU - HK - CA
const countryOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'country', value: 'US' }, "value": "US" },
    { "labelKey": { criteria: 'country', value: 'UK' }, "value": "UK" },
    { "labelKey": { criteria: 'country', value: 'CA' }, "value": "CA" },
    { "labelKey": { criteria: 'country', value: 'MX' }, "value": "MX" },
    { "labelKey": { criteria: 'country', value: 'BR' }, "value": "BR" },
    { "labelKey": { criteria: 'country', value: 'RU' }, "value": "RU" },
    { "labelKey": { criteria: 'country', value: 'HK' }, "value": "HK" },
];

//nyse - nasdaq - amex - euronext - tsx - etf - mutual_fund
const exchangeOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'exchange', value: 'nyse' }, "value": "Nyse" },
    { "labelKey": { criteria: 'exchange', value: 'nasdaq' }, "value": "Nasdaq" },
    { "labelKey": { criteria: 'exchange', value: 'amex' }, "value": "Amex" },
    { "labelKey": { criteria: 'exchange', value: 'euronext' }, "value": "Euronext" },
    { "labelKey": { criteria: 'exchange', value: 'tsx' }, "value": "Tsx" },
    { "labelKey": { criteria: 'exchange', value: 'etf' }, "value": "Etf" },
    { "labelKey": { criteria: 'exchange', value: 'mutual_fund' }, "value": "Mutual Fund" },
];

// Consumer Cyclical - Energy - Technology - Industrials - Financial
const sectorOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'sector', value: 'Basic Materials' }, "value": "Basic Materials" },
    { "labelKey": { criteria: 'sector', value: 'Building' }, "value": "Building" },
    { "labelKey": { criteria: 'sector', value: 'Communication Services' }, "value": "Communication Services" },
    { "labelKey": { criteria: 'sector', value: 'Consumer Cyclical' }, "value": "Consumer Cyclical" },
    { "labelKey": { criteria: 'sector', value: 'Consumer Defensive' }, "value": "Consumer Defensive" },
    { "labelKey": { criteria: 'sector', value: 'Energy' }, "value": "Energy" },
    { "labelKey": { criteria: 'sector', value: 'Financial' }, "value": "Financial" },
    { "labelKey": { criteria: 'sector', value: 'Financial Services' }, "value": "Financial Services" },
    { "labelKey": { criteria: 'sector', value: 'Healthcare' }, "value": "Healthcare" },
    { "labelKey": { criteria: 'sector', value: 'Industrials' }, "value": "Industrials" },
    { "labelKey": { criteria: 'sector', value: 'Media' }, "value": "Media" },
    { "labelKey": { criteria: 'sector', value: 'Real Estate' }, "value": "Real Estate" },
    { "labelKey": { criteria: 'sector', value: 'Technology' }, "value": "Technology" },
    { "labelKey": { criteria: 'sector', value: 'Utilities' }, "value": "Utilities" },

];

// // Basic Materials - Communication Services - Consumer Defensive 
// const serviceOptions = [
//     { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
//     { "labelKey": { criteria: 'services', value: 'Basic Materials' }, "value": "Basic Materials" },
//     { "labelKey": { criteria: 'services', value: 'Communication Services' }, "value": "Communication Services" },
//     { "labelKey": { criteria: 'services', value: 'Consumer Defensive' }, "value": "Consumer Defensive" },
// ];

// //Industry : Autos - Banks - Banks Diversified - Software - Banks Regional 
// const industryOptions = [
//     { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
//     { "labelKey": { criteria: 'industry', value: 'Autos' }, "value": "Autos" },
//     { "labelKey": { criteria: 'industry', value: 'Banks' }, "value": "Banks" },
//     { "labelKey": { criteria: 'industry', value: 'Banks Diversified' }, "value": "Banks Diversified" },
//     { "labelKey": { criteria: 'industry', value: 'Software' }, "value": "Software" },
//     { "labelKey": { criteria: 'industry', value: 'Banks Regional' }, "value": "Banks Regional" },
// ];

const betaOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'betaLowerThan', value: '0' }, "value": "Under 0" },
    { "labelKey": { criteria: 'betaLowerThan', value: '0.5' }, "value": "Under 0.5" },
    { "labelKey": { criteria: 'betaLowerThan', value: '1' }, "value": "Under 1" },
    { "labelKey": { criteria: 'betaLowerThan', value: '1.5' }, "value": "Under 1.5" },
    { "labelKey": { criteria: 'betaLowerThan', value: '2' }, "value": "Under 2" },
    { "labelKey": { criteria: 'betaMoreThan', value: '0' }, "value": "Over 0" },
    { "labelKey": { criteria: 'betaMoreThan', value: '0.5' }, "value": "Over 0.5" },
    { "labelKey": { criteria: 'betaMoreThan', value: '1' }, "value": "Over 1" },
    { "labelKey": { criteria: 'betaMoreThan', value: '1.5' }, "value": "Over 1.5" },
    { "labelKey": { criteria: 'betaMoreThan', value: '2' }, "value": "Over 2" },
    { "labelKey": { criteria: 'betaMoreThan', value: '2.5' }, "value": "Over 2.5" },
    { "labelKey": { criteria: 'betaMoreThan', value: '3' }, "value": "Over 3" },
    { "labelKey": { criteria: 'betaMoreThan', value: '4' }, "value": "Over 4" },
    { "labelKey": { criteria: 'between', value: '0', from: 0, to: 0.5 }, "value": "0 to 0.5" },
    { "labelKey": { criteria: 'between', value: '0', from: 0.5, to: 1 }, "value": "0.5 to 1" },
    { "labelKey": { criteria: 'between', value: '0', from: 0.5, to: 1.5 }, "value": "0.5 to 1.5" },
    { "labelKey": { criteria: 'between', value: '0', from: 1, to: 1.5 }, "value": "1 to 1.5" },
    { "labelKey": { criteria: 'between', value: '0', from: 1.5, to: 2 }, "value": "1.5 to 2" },
];

const volumeOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'volumeLowerThan', value: '50000' }, "value": "Under 50k" },
    { "labelKey": { criteria: 'volumeLowerThan', value: '100000' }, "value": "Under 100k" },
    { "labelKey": { criteria: 'volumeLowerThan', value: '500000' }, "value": "Under 500k" },
    { "labelKey": { criteria: 'volumeLowerThan', value: '750000' }, "value": "Under 750k" },
    { "labelKey": { criteria: 'volumeLowerThan', value: '1000000' }, "value": "Under 1M" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '50000' }, "value": "Over 50k" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '100000' }, "value": "Over 100k" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '500000' }, "value": "Over 500k" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '750000' }, "value": "Over 750k" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '1000000' }, "value": "Over 1M" },
    { "labelKey": { criteria: 'volumeMoreThan', value: '2000000' }, "value": "Over 2M" },
    { "labelKey": { criteria: 'between', value: '0', from: 100000, to: 500000 }, "value": "100k to 500k" },
    { "labelKey": { criteria: 'between', value: '0', from: 100000, to: 1000000 }, "value": "100k to 1M" },
    { "labelKey": { criteria: 'between', value: '0', from: 500000, to: 1000000 }, "value": "500k to 1M" },
    { "labelKey": { criteria: 'between', value: '0', from: 500000, to: 10000000 }, "value": "500k to 10M" },
];

const dividendOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'dividendLowerThan', value: '0' }, "value": "Under 0" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '0' }, "value": "Over 0" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '1' }, "value": "Over 1%" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '2' }, "value": "Over 2%" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '4' }, "value": "Over 4%" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '8' }, "value": "Over 8%" },
    { "labelKey": { criteria: 'dividendMoreThan', value: '10' }, "value": "Over 10%" },
    { "labelKey": { criteria: 'between', value: '0', from: 0, to: 1 }, "value": "0 to 1%" },
    { "labelKey": { criteria: 'between', value: '0', from: 1, to: 2 }, "value": "1% to 2%" },
    { "labelKey": { criteria: 'between', value: '0', from: 2, to: 5 }, "value": "2% to 5%" },
    { "labelKey": { criteria: 'between', value: '0', from: 5, to: 10 }, "value": "5% to 10%" },
];

const marketCapOptions = [
    { "labelKey": { criteria: '', value: '' }, "value": "Any", "isSelected": true },
    { "labelKey": { criteria: 'marketCapMoreThan', value: '200000000000' }, "value": "Mega (200B and more)" },
    { "labelKey": { criteria: 'between', value: '0', from: '10000000000', to: '200000000000' }, "value": "Large (10B to 200B)" },
    { "labelKey": { criteria: 'between', value: '0', from: '2000000000', to: '10000000000' }, "value": "Mid (2B to 10B)" },
    { "labelKey": { criteria: 'between', value: '0', from: '300000000', to: '2000000000' }, "value": "Small (300M to 2B)" },
    { "labelKey": { criteria: 'between', value: '0', from: '50000000', to: '300000000' }, "value": "Micro (50M to 300M)" },
    { "labelKey": { criteria: 'marketCapLowerThan', value: '50000000' }, "value": "Nano (Under 50M)" },

    { "labelKey": { criteria: 'marketCapMoreThan', value: '10000000000' }, "value": "Large (Over 10B)" },
    { "labelKey": { criteria: 'marketCapMoreThan', value: '2000000000' }, "value": "Mid (Over 2B)" },
    { "labelKey": { criteria: 'marketCapMoreThan', value: '300000000' }, "value": "Small (Over 300M)" },
    { "labelKey": { criteria: 'marketCapMoreThan', value: '50000000' }, "value": "Micro (Over 50M)" },

    { "labelKey": { criteria: 'marketCapLowerThan', value: '100000000000' }, "value": "Large (Under 100B)" },
    { "labelKey": { criteria: 'marketCapLowerThan', value: '10000000000' }, "value": "Mid (Under 10B)" },
    { "labelKey": { criteria: 'marketCapLowerThan', value: '2000000000' }, "value": "Small (Under 2B)" },
    { "labelKey": { criteria: 'marketCapLowerThan', value: '300000000' }, "value": "Micro (Under 300M)" },

];



class ScreenerCriteria extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reload : false,
            preselectedCountry: undefined,
            preselectedSector: undefined
        };
        this.criteriaChanged = false;
        this.globalSearchCriteria = [];
        this.selectedCountry = [];
        this.selectedPrice = [];
        this.selectedExchange = [];
        this.selectedSector = [];
        this.selectedService = [];
        this.selectedIndustry = [];
        this.selectedBeta = [];
        this.selectedDividend = [];
        this.selectedMarketCap = [];

        
    }

    componentDidMount() {
        console.log('screencriteria query params', this.props);
        if (this.props !== undefined && Object.keys(this.props).length > 0) {
            let { country, sector } = this.props;
            country = country.toString().toUpperCase();
            sector = sector.toString().toUpperCase();
            console.log('screencriteria, country', country, sector);
            let updateScreener = false;

            //Preselect country
            if (country !== undefined) {
                this.selectedCountry = [];
                let tmpObj = {
                    selectedKey: [
                        { criteria: 'country', value: country }
                    ],
                    selectedValue: []
                }
                //this.selectedCountry.push(tmpObj);
                this.selectedCountry = tmpObj;
                for (var i=0; i<countryOptions.length; i++){
                    if (countryOptions[i].labelKey.value === country){
                        this.setState({preselectedCountry: countryOptions[i], reload: true});
                        break;
                    }
                }
                //this.handleCountryChange(countryOptions[1]);
                updateScreener = true;
            }

            //Preselect sector
            if (sector !== undefined) {
                this.selectedSector = [];
                let tmpObj = {
                    selectedKey: [
                        { criteria: 'sector', value: sector }
                    ],
                    selectedValue: []
                }
                //this.selectedSector.push(tmpObj);
                this.selectedSector = tmpObj;
                for (i=0; i<sectorOptions.length; i++){
                    if (sectorOptions[i].labelKey.value.toUpperCase() === sector){
                        this.setState({preselectedSector: sectorOptions[i], reload: true});
                        break;
                    }
                }
                updateScreener = true;
            }

            if (updateScreener) {
                console.log('buildcriteria', this.selectedCountry, this.selectedSector); 
                this.criteriaChanged = true;
                this.buildCriteria();
            }
        }
    }


    buildCriteria() {
        this.globalSearchCriteria = [];
        console.log('Screen Criteria', this.globalSearchCriteria, this.selectedCountry, this.selectedPrice);

        //Selected Country
        if (this.selectedCountry !== undefined && this.selectedCountry.selectedKey !== undefined) {
            const key = this.selectedCountry.selectedKey[0];
            //const value = this.selectedCountry.selectedValue[0];
            let tmpObj = { col: 'country', criteria: key.criteria, value: key.value };
            this.globalSearchCriteria.push(tmpObj);
            this.criteriaChanged = true;
        }

        //Selected Price
        if (this.selectedPrice !== undefined && this.selectedPrice.selectedKey !== undefined) {
            const key = this.selectedPrice.selectedKey[0];
            //const value = this.selectedPrice.selectedValue[0];
            let tmpObj = { col: 'price', criteria: key.criteria, value: key.value };
            if (key.criteria === 'between') {
                tmpObj = { col: 'price', criteria: 'priceMoreThan', value: key.from };
                this.globalSearchCriteria.push(tmpObj);

                tmpObj = { col: 'price', criteria: 'priceLowerThan', value: key.to };
                this.globalSearchCriteria.push(tmpObj);
            } else {
                this.globalSearchCriteria.push(tmpObj);
            }
            this.criteriaChanged = true;
        }

        //Selected Exchange
        if (this.selectedExchange !== undefined && this.selectedExchange.selectedKey !== undefined) {
            const key = this.selectedExchange.selectedKey[0];
            //const value = this.selectedExchange.selectedValue[0];
            let tmpObj = { col: 'exchange', criteria: key.criteria, value: key.value };
            this.globalSearchCriteria.push(tmpObj);
            this.criteriaChanged = true;
        }

        //Selected Sector Consumer Cyclical - Energy - Technology - Industrials - Financial
        if (this.selectedSector !== undefined && this.selectedSector.selectedKey !== undefined) {
            const key = this.selectedSector.selectedKey[0];
            //const value = this.selectedSector.selectedValue[0];
            let tmpObj = { col: 'sector', criteria: key.criteria, value: key.value };
            this.globalSearchCriteria.push(tmpObj);
            this.criteriaChanged = true;
        }

        if (this.selectedService !== undefined && this.selectedService.selectedKey !== undefined) {
            const key = this.selectedService.selectedKey[0];
            //const value = this.selectedService.selectedValue[0];
            let tmpObj = { col: 'services', criteria: key.criteria, value: key.value };
            this.globalSearchCriteria.push(tmpObj);
            this.criteriaChanged = true;
        }

        if (this.selectedIndustry !== undefined && this.selectedIndustry.selectedKey !== undefined) {
            const key = this.selectedIndustry.selectedKey[0];
            //const value = this.selectedIndustry.selectedValue[0];
            let tmpObj = { col: 'industry', criteria: key.criteria, value: key.value };
            this.globalSearchCriteria.push(tmpObj);
            this.criteriaChanged = true;
        }

        if (this.selectedBeta !== undefined && this.selectedBeta.selectedKey !== undefined) {
            const key = this.selectedBeta.selectedKey[0];
            //const value = this.selectedBeta.selectedValue[0];
            let tmpObj = { col: 'beta', criteria: key.criteria, value: key.value };
            if (key.criteria === 'between') {
                tmpObj = { col: 'beta', criteria: 'betaMoreThan', value: key.from };
                this.globalSearchCriteria.push(tmpObj);

                tmpObj = { col: 'beta', criteria: 'betaLowerThan', value: key.to };
                this.globalSearchCriteria.push(tmpObj);
            } else {
                this.globalSearchCriteria.push(tmpObj);
            }
            this.criteriaChanged = true;
        }

        if (this.selectedVolume !== undefined && this.selectedVolume.selectedKey !== undefined) {
            const key = this.selectedVolume.selectedKey[0];
            //const value = this.selectedVolume.selectedValue[0];
            let tmpObj = { col: 'volume', criteria: key.criteria, value: key.value };
            if (key.criteria === 'between') {
                tmpObj = { col: 'volume', criteria: 'volumeMoreThan', value: key.from };
                this.globalSearchCriteria.push(tmpObj);

                tmpObj = { col: 'volume', criteria: 'volumeLowerThan', value: key.to };
                this.globalSearchCriteria.push(tmpObj);
            } else {
                this.globalSearchCriteria.push(tmpObj);
            }
            this.criteriaChanged = true;
        }

        if (this.selectedDividend !== undefined && this.selectedDividend.selectedKey !== undefined) {
            const key = this.selectedDividend.selectedKey[0];
            //const value = this.selectedDividend.selectedValue[0];
            let tmpObj = { col: 'dividend', criteria: key.criteria, value: key.value };
            if (key.criteria === 'between') {
                tmpObj = { col: 'dividend', criteria: 'dividendMoreThan', value: key.from };
                this.globalSearchCriteria.push(tmpObj);

                tmpObj = { col: 'dividend', criteria: 'dividendLowerThan', value: key.to };
                this.globalSearchCriteria.push(tmpObj);
            } else {
                this.globalSearchCriteria.push(tmpObj);
            }
            this.criteriaChanged = true;
        }

        if (this.selectedMarketCap !== undefined && this.selectedMarketCap.selectedKey !== undefined) {
            const key = this.selectedMarketCap.selectedKey[0];
            //const value = this.selectedMarketCap.selectedValue[0];
            let tmpObj = { col: 'marketcap', criteria: key.criteria, value: key.value };
            if (key.criteria === 'between') {
                tmpObj = { col: 'marketcap', criteria: 'marketCapMoreThan', value: key.from };
                this.globalSearchCriteria.push(tmpObj);

                tmpObj = { col: 'marketcap', criteria: 'marketCapLowerThan', value: key.to };
                this.globalSearchCriteria.push(tmpObj);
            } else {
                this.globalSearchCriteria.push(tmpObj);
            }
            this.criteriaChanged = true;
        }


        console.log('Screen Criteria-1', this.globalSearchCriteria);

        if (this.criteriaChanged) {
            this.triggerSearch();
            this.criteriaChanged = false;
        }

    }

    selectUpdateObj(selectedOptions) {
        let tmpObj = {
            selectedKey: [
                JSON.parse(selectedOptions.target.value)
            ],
            selectedValue: []
        }
        return tmpObj;
    }

    handleCountryChange = (selectedOptions) => {
        this.selectedCountry = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected country', this.selectedCountry, selectedOptions);
        this.buildCriteria();
    }

    handlePriceChange = (selectedOptions) => {
        this.selectedPrice = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected price', this.selectedPrice, selectedOptions);
        this.buildCriteria();
    }

    handleExchangeChange = (selectedOptions) => {
        this.selectedExchange = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected exchange', this.selectedExchange, selectedOptions);
        this.buildCriteria();
    }

    handleSectorChange = (selectedOptions) => {
        this.selectedSector = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected sector', this.selectedSector, selectedOptions);
        this.buildCriteria();
    }

    handleServicesChange = (selectedOptions) => {
        this.selectedService = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected sector', this.selectedService, selectedOptions);
        this.buildCriteria();
    }

    handleIndustryChange = (selectedOptions) => {
        this.selectedIndustry = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected Industry', this.selectedIndustry, selectedOptions);
        this.buildCriteria();
    }

    handleBetaChange = (selectedOptions) => {
        this.selectedBeta = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected Beta', this.selectedBeta, selectedOptions);
        this.buildCriteria();
    }

    handleVolumeChange = (selectedOptions) => {
        this.selectedVolume = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected Volume', this.selectedVolume, selectedOptions);
        this.buildCriteria();
    }

    handleDividendChange = (selectedOptions) => {
        this.selectedDividend = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected Dividend', this.selectedDividend, selectedOptions);
        this.buildCriteria();
    }

    handleMarketCapChange = (selectedOptions) => {
        this.selectedMarketCap = this.selectUpdateObj(selectedOptions);
        console.log('Screen Criteria -selected MarketCap', this.selectedMarketCap, selectedOptions);
        this.buildCriteria();
    }


    triggerSearch() {
        console.log('Triggering screensearch publish');
        PubSub.publish('screenSearch', this.globalSearchCriteria);
    }

    render() {
        if (this.state.reload) {
			console.log('Screener criteria Reloading...');
			this.setState({ reload: false });
			return <div>Loading...</div>;
		}
		
        return (
            <div>
                <Container fluid className="p-2">
                    <Card>
                        <Card.Header>Screener</Card.Header>
                        <Card.Body>
                            {/* <Card.Text> */}
                            <Row>
                                <Col md>
                                    <ScreenerSelect options={countryOptions} onChange={this.handleCountryChange} label={'Country'} value={this.state.preselectedCountry}/>
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={exchangeOptions} onChange={this.handleExchangeChange} label={'Exchange'} />
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={sectorOptions} onChange={this.handleSectorChange} label={'Sector'} value={this.state.preselectedSector}/>
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={priceOptions} onChange={this.handlePriceChange} label={'Price'} />
                                </Col>
                            </Row>
                            <Row><p></p></Row>
                            <Row>
                                <Col md>
                                    <ScreenerSelect options={marketCapOptions} onChange={this.handleMarketCapChange} label={'Market Cap'} />
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={betaOptions} onChange={this.handleBetaChange} label={'Beta'} />
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={volumeOptions} onChange={this.handleVolumeChange} label={'Volume'} />
                                </Col>
                                <Col md>
                                    <ScreenerSelect options={dividendOptions} onChange={this.handleDividendChange} label={'Dividend'} />
                                </Col>
                            </Row>
                            {/* </Card.Text> */}
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        );
    }
}

export default ScreenerCriteria;
